// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "@microsoft/applicationinsights-core-js";
export var StorageType = (/*@__PURE__*/createEnumStyle({
    Unknown: 0 /* eStorageType.Unknown */,
    LocalStorage: 1 /* eStorageType.LocalStorage */,
    SessionStorage: 2 /* eStorageType.SessionStorage */,
    IndexDb: 3 /* eStorageType.IndexDb */
}));
export var BatchSendStatus = (/*@__PURE__*/createEnumStyle({
    Complete: 1 /* eBatchSendStatus.Complete */,
    Retry: 2 /* eBatchSendStatus.Retry */,
    Drop: 3 /* eBatchSendStatus.Drop */,
    Failure: 4 /* eBatchSendStatus.Failure */
}));
export var BatchStoreStatus = (/*@__PURE__*/createEnumStyle({
    Success: 1 /* eBatchStoreStatus.Success */,
    Failure: 2 /* eBatchStoreStatus.Failure */
}));
//export declare type createOfflineBatchHandler = (storageType: eStorageType, cfg?: IOfflineBatchHandlerCfg) => IOfflineBatchHandler;
//# sourceMappingURL=IOfflineBatch.js.map